import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Moment from 'react-moment';
import { FaFilter as Filtro } from 'react-icons/fa';
import { SiSessionize as IconSessione } from 'react-icons/si';
import { BiSolidBriefcaseAlt as Valigia } from 'react-icons/bi';
import { FaUserGroup as IconaGruppi } from 'react-icons/fa6';
import { FaBed as IconaPernottamento } from 'react-icons/fa';
import { ImKey2 as IconaTestDrive } from 'react-icons/im';
import { FaWheatAwnCircleExclamation as IconaIntolleranze } from 'react-icons/fa6';
import { IoRestaurant as Cena } from 'react-icons/io5';
import { BsFillCarFrontFill as Car } from 'react-icons/bs';
import { FaPlane as Plane } from 'react-icons/fa';
import { FaTrainSubway as Train } from 'react-icons/fa6';
import { MdOutlineNoPhotography as IconaConsensoFoto } from 'react-icons/md';

function IconePartecipante({ partecipante }) {
  // Controllo mezzo
  let mezzo =
    partecipante.mezzoTrasporto === 'aereo' ? (
      <Plane />
    ) : partecipante.mezzoTrasporto === 'treno' ? (
      <Train />
    ) : partecipante.mezzoTrasporto === 'auto' ? (
      <Car />
    ) : (
      ''
    );

  // Controllo cena
  let cena = partecipante.cena ? <Cena /> : '';

  // Pernottamento
  let pernottamento = partecipante.pernottamento ? <IconaPernottamento /> : '';

  // Intolleranze
  let intolleranze = partecipante.intolleranzeAlimentari ? (
    <IconaIntolleranze />
  ) : (
    ''
  );

  // Pernottamento
  let consensoUsoImmagine = !partecipante.consensoUsoImmagine ? (
    <IconaConsensoFoto />
  ) : (
    ''
  );

  // Test Drive
  let testDrive = partecipante.effettuaTestDrive ? <IconaTestDrive /> : '';

  return (
    <>
      {mezzo && <div className="icona-partecipante">{mezzo}</div>}
      {cena && <div className="icona-partecipante">{cena}</div>}
      {pernottamento && (
        <div className="icona-partecipante">{pernottamento}</div>
      )}
      {intolleranze && <div className="icona-partecipante">{intolleranze}</div>}
      {testDrive && <div className="icona-partecipante">{testDrive}</div>}
      {consensoUsoImmagine && (
        <div className="icona-partecipante">{consensoUsoImmagine}</div>
      )}
    </>
  );
}

export default IconePartecipante;
